import React, { useEffect, useMemo } from "react";
import { Circle, MapContainer, Marker, Pane, TileLayer, useMap } from "react-leaflet";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import { Localize } from "components/service";
import { getStaffScanMapPositions } from "../helpers/staff-scan-location-helper";
import "leaflet/dist/leaflet.css";


delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
});

const StaffScanViewport = ({ positions }) => {
    const map = useMap();

    useEffect(() => {
        if (positions.zone)
        {
            const bounds = L.latLng(positions.zone.center)
                .toBounds(positions.zone.radius * 2);

            bounds.extend(positions.scan);
            map.fitBounds(bounds, {
                animate: false,
                maxZoom: 17,
                padding: [ 30, 30 ],
            });
        }
        else
        {
            map.setView(positions.scan, 17, { animate: false });
        }

        window.setTimeout(() => map.invalidateSize(), 0);
    }, [ map, positions ]);

    return null;
};

const StaffScanLocationMap = ({ scan, zone }) => {
    const positions = useMemo(() => (
        getStaffScanMapPositions({ scan, zone })
    ), [ scan, zone ]);

    if (!positions)
    {
        return null;
    }

    return (
        <div className="staff-scan-location-map">
            <span className="visually-hidden">
                <Localize>STAFF_MANAGEMENT.ScanModal_Location</Localize>:{ " " }
                { scan.latitude }, { scan.longitude }
            </span>
            { positions.zone &&
                <span className="visually-hidden">
                    <Localize
                        latitude={ zone.latitude }
                        longitude={ zone.longitude }
                        radius={ zone.radius }>
                        STAFF_MANAGEMENT.ScanModal_ZoneDescription
                    </Localize>
                </span>
            }
            <MapContainer
                center={ positions.scan }
                zoom={ 17 }
                scrollWheelZoom={ true }
                className="staff-scan-location-map__leaflet">
                <TileLayer
                    attribution="&copy; OpenStreetMap contributors"
                    url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
                <StaffScanViewport positions={ positions } />
                <Pane name="scan-accuracy" style={ { zIndex: 399, pointerEvents: "none" } }>
                    { typeof scan.accuracy === "number" && Number.isFinite(scan.accuracy) && scan.accuracy > 0 &&
                        <Circle
                            center={ positions.scan }
                            radius={ scan.accuracy }
                            interactive={ false }
                            pathOptions={ {
                                color: "#2563eb",
                                weight: 1.5,
                                dashArray: "4, 4",
                                fillColor: "#3b82f6",
                                fillOpacity: 0.15,
                            } } />
                    }
                </Pane>
                { positions.zone &&
                    <Circle
                        center={ positions.zone.center }
                        radius={ positions.zone.radius }
                        pathOptions={ {
                            color: "#ec008c",
                            fillColor: "#ec008c",
                            fillOpacity: 0.18,
                        } } />
                }
                <Marker position={ positions.scan } />
            </MapContainer>
        </div>
    );
};

export default StaffScanLocationMap;
